import { useDispatch } from '@redux';
import {
  getByIdOrdersReturn,
  paymentRefund,
} from '@redux/ordersReturn/actions';
import { Form, Modal } from 'antd';
import FormItem from 'components/form/FormItem';
import useToggleModal from 'hooks/useToogleModal';
import React, { useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';

const ConfirmRefundModal = ({ id, reason }, ref) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const { visible, toggleModal } = useToggleModal();
  const [loading, setLoading] = useState(false);

  useImperativeHandle(ref, () => ({
    open: () => {
      toggleModal();
    },
  }));

  const handleValidation = async (values) => {
    setLoading(true);
    dispatch(
      paymentRefund({ data: { id: id, data: { reason, note: values.note } } }),
    )
      .then(() => {
        dispatch(
          getByIdOrdersReturn({
            data: { id: id },
            options: { isRequestApi: true, isRefresh: true },
          }),
        ).finally(() => {
          setLoading(false);
          if (visible) toggleModal();
        });
      })
  };

  return (
    <Modal
      open={visible}
      title={t('ordersReturn.note')}
      onCancel={() => visible && toggleModal()}
      onOk={() => form.submit()}
      width={462}
      confirmLoading={loading}
    >
      <Form form={form} layout="vertical" onFinish={handleValidation}>
        <FormItem
          name="note"
          label={t('ordersReturn.noteYourReason')}
          required
        />
      </Form>
    </Modal>
  );
};

export default React.forwardRef(ConfirmRefundModal);
